import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import InlineLink from '../../inline-link';

// https://github.com/facebook/react/issues/3386#issuecomment-78605760
const parseText = (text) => {
  const pattern = /\[(.*?)\]\((.*?)\)/i;
  const patternNoGroups = /(\[.*?\]\(.*?\))/gi;
  const match = text.match(pattern);

  if (!match || (match && match.length < 3)) return text;

  const parts = text.split(patternNoGroups);

  for (let i = 1; i < parts.length; i += 2) {
    parts[i] = <InlineLink href={match[2]} key={i}>{match[1]}</InlineLink>;
  }

  return parts;
};

const MdLink = ({ source }) => (
  <Fragment>
    {parseText(source)}
  </Fragment>
);

MdLink.propTypes = {
  source: PropTypes.string.isRequired,
};

export default MdLink;
